/*
 * Admin Logs tab: list of API logs and log detail modal.
 */

import React from "react";
import { FaTimes } from "react-icons/fa";
import i18n from "../../../i18n/i18n.js";
import LogDetailModal from "../modals/LogDetailModal.jsx";

export default function AdminLogsTab({
  loadingLogs,
  logsError,
  loadLogs,
  logs,
  setSelectedLog,
  selectedLog,
  organization,
  activeUserEmail,
  getTextDirection,
}) {
  const domain = organization?.name || (activeUserEmail ? activeUserEmail.split("@")[1] : "N/A");

  return (
    <div className="flex-1 flex flex-col gap-4 overflow-hidden">
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm flex-1 flex flex-col overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-200">
          <h3 className="text-sm font-semibold text-gray-900">{i18n.t("logs.apiLogs")}</h3>
          <p className="text-xs text-gray-500 mt-1">
            {i18n.t("logs.showingLogsForDomain")} {domain}
          </p>
        </div>
        <div className="flex-1 overflow-y-auto p-4">
          {loadingLogs ? (
            <div className="text-center py-8 text-gray-600">{i18n.t("logs.loadingLogs")}</div>
          ) : logsError ? (
            <div className="text-center py-8 text-red-600">
              <p>
                {i18n.t("logs.errorLoadingLogs")} {logsError}
              </p>
              <button
                onClick={loadLogs}
                className="mt-4 px-4 py-2 bg-[#46A2F2] text-white rounded-md hover:bg-[#0C75D1] text-sm"
              >
                {i18n.t("logs.retry")}
              </button>
            </div>
          ) : logs.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <p>{i18n.t("logs.noLogsFound")}</p>
            </div>
          ) : (
            <div className="space-y-3">
              {logs.map((log) => (
                <div
                  key={log.id}
                  className={`border rounded-lg p-3 cursor-pointer transition-colors ${
                    log.statusCode >= 400 || log.errorMessage
                      ? "border-red-200 bg-red-50"
                      : "border-gray-200 bg-gray-50"
                  } hover:bg-gray-100`}
                  onClick={() => setSelectedLog(log)}
                >
                  <div
                    className={`flex items-center justify-between mb-2 ${getTextDirection() === "rtl" ? "flex-row-reverse" : ""}`}
                  >
                    <div
                      className={`flex items-center gap-2 ${getTextDirection() === "rtl" ? "flex-row-reverse" : ""}`}
                    >
                      <span
                        className={`px-2 py-1 rounded text-xs font-semibold ${
                          log.method === "GET"
                            ? "bg-blue-100 text-blue-700"
                            : log.method === "POST"
                              ? "bg-green-100 text-green-700"
                              : log.method === "PUT"
                                ? "bg-yellow-100 text-yellow-700"
                                : "bg-red-100 text-red-700"
                        }`}
                      >
                        {log.method}
                      </span>
                      <span
                        className={`px-2 py-1 rounded text-xs font-semibold ${
                          log.statusCode >= 200 && log.statusCode < 300
                            ? "bg-green-100 text-green-700"
                            : log.statusCode >= 400
                              ? "bg-red-100 text-red-700"
                              : "bg-gray-100 text-gray-700"
                        }`}
                      >
                        {log.statusCode || "N/A"}
                      </span>
                    </div>
                    <span className="text-xs text-gray-500">
                      {new Date(log.createdAt).toLocaleString()}
                    </span>
                  </div>
                  <div className="text-sm text-gray-700 truncate">{log.path}</div>
                  {log.errorMessage && (
                    <div className="mt-2 text-xs text-red-600 truncate">
                      {i18n.t("logs.error")} {log.errorMessage}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {selectedLog && (
        <LogDetailModal
          log={selectedLog}
          onClose={() => setSelectedLog(null)}
          getTextDirection={getTextDirection}
        />
      )}
    </div>
  );
}
